import { NEVER } from 'rxjs'
import { ApiClient } from '@/infra/api-client'
import { env } from '@/infra/env'

/**
 * API for Email Confirmation.
 */
export class EmailConfirmationApi extends ApiClient {
  constructor() {
    super({
      token$: NEVER,
      baseURL: env.IAM_API,
    })
  }

  /**
   * Queries for the verification status of a user.
   */
  getVerificationStatus(token: string): Promise<boolean> {
    return this._get<{ verified: boolean }>(
      'v1/email-verification/status',
      undefined,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    ).then((o) => o.verified)
  }

  /**
   * Resends verification emails.
   */
  async resendEmail(token: string) {
    const request = new Request(
      this._createURL('v1/email-verification/resend'),
      { method: 'POST', headers: { Authorization: `Bearer ${token}` } },
    )

    await this._send(request).then(ApiClient.throwIfNotSuccessful)
  }
}
